import { talentPicture } from "components/Screens/Marketplace/Customer/utils/redaction";
import type { TalentListItem } from "components/Screens/Marketplace/Customer/types";
import "components/Screens/Marketplace/Customer/common/Withheld/Withheld.scss";
import "./ProtoAvatar.scss";

// Prototype avatar(): initials on a colour picked from the id, the photo on top. A withheld photo shows the
// illustrated avatar for the talent's gender (product 2026-10-23), or the initials.
const AV_COLORS = ["#4a0f70", "#300331", "#914de8", "#213781", "#498ebd", "#003731", "#586763", "#de5523"];

export const avColor = (id: string) => {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AV_COLORS[h % AV_COLORS.length];
};

function ProtoAvatar({ talent, size = 48 }: { talent: TalentListItem; size?: number }) {
  const initials = `${talent.firstName?.[0] || ""}${talent.lastInitial || talent.lastName?.[0] || ""}`.toUpperCase();
  const picture = talentPicture(talent);
  return (
    <div className="av" style={{ width: size, height: size }}>
      {/* eslint-disable-next-line no-underscore-dangle */}
      <div className="ini" style={{ background: avColor(talent._id), fontSize: Math.round(size * 0.35) }}>
        {initials}
      </div>
      {picture && <img src={picture} alt="" />}
    </div>
  );
}

export default ProtoAvatar;
